import { getRequiredVariables } from '../../src';
export var containMainVariableValidator = function (value, _a) {
    var urlMappingKey = _a.urlMappingKey;
    var required = getRequiredVariables(urlMappingKey);
    return required === null || required === void 0 ? void 0 : required.every(function (main) { return value === null || value === void 0 ? void 0 : value.includes("{{".concat(main, "}}")); });
};
//# sourceMappingURL=contain-main-variable-validator.js.map